import React, { useState, useEffect } from "react";
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, List, ListItem, ListItemText, ListItemAvatar,
  Avatar, Typography, CircularProgress, InputAdornment,
} from "@mui/material";
import { Search, MergeType } from "@mui/icons-material";
import { toast } from "react-toastify";
import api from "../../services/api";
import toastError from "../../errors/toastError";

const MergeTicketModal = ({ open, onClose, ticketId }) => {
  const [search, setSearch] = useState("");
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState(null);
  const [merging, setMerging] = useState(false);

  useEffect(() => {
    if (!open) return;
    setSearch(""); setSelected(null);
    setLoading(true);
    api.get("/tickets", { params: { status: "open", pageNumber: 1 } })
      .then(({ data }) => setTickets((data.tickets || []).filter(t => t.id !== ticketId)))
      .catch(toastError)
      .finally(() => setLoading(false));
  }, [open, ticketId]);

  const filtered = tickets.filter(t => {
    const q = search.toLowerCase();
    return (t.contact?.name || "").toLowerCase().includes(q) || (t.contact?.number || "").includes(q);
  });

  const handleMerge = async () => {
    if (!selected) return;
    if (!window.confirm(`Mesclar ticket #${selected.id} (${selected.contact?.name}) neste? As mensagens serão movidas e o outro será fechado.`)) return;
    setMerging(true);
    try {
      await api.post(`/tickets/${ticketId}/merge`, { sourceTicketId: selected.id });
      toast.success("Tickets mesclados com sucesso.");
      onClose();
    } catch (err) { toastError(err); }
    setMerging(false);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle><MergeType sx={{ mr: 1, verticalAlign: "middle" }} />Mesclar com outro ticket</DialogTitle>
      <DialogContent sx={{ p: 0 }}>
        <div style={{ padding: "8px 16px" }}>
          <TextField fullWidth size="small" placeholder="Buscar contato..." variant="outlined"
            value={search} onChange={e => setSearch(e.target.value)}
            InputProps={{ startAdornment: <InputAdornment position="start"><Search fontSize="small" /></InputAdornment> }} />
        </div>
        {loading ? (
          <div style={{ display: "flex", justifyContent: "center", padding: 24 }}><CircularProgress size={28} /></div>
        ) : (
          <List disablePadding sx={{ maxHeight: 300, overflowY: "auto" }}>
            {filtered.map(t => (
              <ListItem key={t.id} button onClick={() => setSelected(t)} selected={selected?.id === t.id} divider>
                <ListItemAvatar><Avatar src={t.contact?.profilePicUrl} /></ListItemAvatar>
                <ListItemText primary={t.contact?.name || t.contact?.number} secondary={`#${t.id} · ${t.contact?.number}`} />
              </ListItem>
            ))}
            {!loading && filtered.length === 0 && (
              <Typography sx={{ p: 2, textAlign: "center", color: "gray" }}>Nenhum ticket encontrado.</Typography>
            )}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={merging}>Cancelar</Button>
        <Button onClick={handleMerge} variant="contained" color="primary" disabled={!selected || merging}>
          {merging ? <CircularProgress size={18} /> : "Mesclar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MergeTicketModal;
